function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgShareAndroid = function SvgShareAndroid(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: props.fill,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M5.993 14.67a3.337 3.337 0 1 0 0-6.675 3.337 3.337 0 0 0 0 6.675M18.007 9.998a3.337 3.337 0 1 0 0-6.675 3.337 3.337 0 0 0 0 6.675M18.007 20.677a3.337 3.337 0 1 0 0-6.674 3.337 3.337 0 0 0 0 6.674M9.104 10.123l5.792-2.252M8.979 12.826l6.043 3.021"
  }));
};
export default SvgShareAndroid;